export default __webpack_public_path__ + "static/media/create-campaigns-6.2470cdee.png";